require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./journal-top-36-marble-bathrooms-middle-park-residence-in-vogue-living.json") })
        }
      }, "path---journal-top-36-marble-bathrooms-middle-park-residence-in-vogue-living");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---journal-top-36-marble-bathrooms-middle-park-residence-in-vogue-living!./.cache/json/journal-top-36-marble-bathrooms-middle-park-residence-in-vogue-living.json
// module id = 549
// module chunks = 231608221292675